import { Chip } from '@mui/material';
import { useCmsRequest, usePreference } from '@tyro/api';
import { useMemo } from 'react';
import { tyroTuitionCoursesIdsPathName } from '../utils/api-config';
import type { CourseDataType } from '../utils/types';

export function UnViewedTuitionCountLabel() {
  const { data: fetchCourseIds } = useCmsRequest<{
    data: Pick<CourseDataType, 'id'>[];
  }>(tyroTuitionCoursesIdsPathName);
  const [viewedTuitions] = usePreference('tyro-tuition.viewed-ids', []);

  const count = useMemo(() => {
    if (!fetchCourseIds) return 0;
    return fetchCourseIds?.data.filter(({ id }) => !viewedTuitions.includes(id))
      .length;
  }, [fetchCourseIds, viewedTuitions]);

  if (count === 0) return null;

  return (
    <Chip
      label={count}
      size="small"
      variant="soft"
      color="error"
      sx={{
        borderRadius: 0.75,
      }}
    />
  );
}
